import React, { FC } from 'react';

import { CommonError } from 'src/components/common-error/common-error';
import { i18n } from 'src/i18n';
import { bigTvImageProps } from 'src/resources/images';

export const PageMultipleTvOffers: FC = () => (
  <CommonError
    title={i18n.page.error.multipleTvOffers.title}
    subtitle={[i18n.page.error.multipleTvOffers.description, i18n.page.error.multipleTvOffers.tryAgainLater]}
    image={bigTvImageProps}
  />
);
